import type { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import { IBlogAuthor, IJustIn, IPageMenu, ITrend } from '@/interfaces';
import { CountryCode } from '@/lib/constants';
import { Justin, TopAuthors, TrendsBanner, TrendsParentCats } from '@/components/trends';
import blogService from '@/lib/services/blogService';
import {  IMetaHead } from '@/interfaces/IMetaHead';
import { MetaHead } from '@/components/shared/metaHead';
import { BreadCrumb } from '@/components/shared/breadCrumb';
import { SchemaHead } from '@/components/shared/schemaHead';
type Props = {
  data: ITrend[]
  JustinData:IJustIn[],
  authors:IBlogAuthor[],
  navSchemaData:IPageMenu[]
}
const Trends: NextPage<Props> = ({ data ,JustinData,authors,navSchemaData}) => {
  const metaData: IMetaHead = {
    title: "Interior Design and Decorating Tips | Best Interior Design Blog",
    description: "Get the latest home interior decorating tips from our Interior Experts. Know everything about interiors on our Blog section and decor home in Your own style.",
    hreflangNotRequired:true,
    ogImage:`${process.env.SITE_URL}/assets/images/trendsBanner.svg?w=768&q=80`
  };
  return (
    <>
      <MetaHead metaData={metaData} />
      <BreadCrumb />      
      <SchemaHead navSchemaData={navSchemaData}/>
      <TrendsBanner/>
      <TrendsParentCats data={data} countryCode={CountryCode.INR} />
      <Justin JustinData={JustinData} countryCode={CountryCode.INR} />
      <TopAuthors authors={authors} countryCode={CountryCode.INR} />
    </>
  )

}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const data = (await blogService.getTrendList(CountryCode.INR)) || {};
  const JustinData = (await blogService.getJustInData(CountryCode.INR)) || {};
  const authors=await blogService.getAuthors(CountryCode.INR);
  if (!data || data.length == 0 ||!JustinData || JustinData.length == 0 || !authors || authors.length == 0 )
    return { notFound: true }
  return {
    props: { data,JustinData,authors },
  }
}
export default Trends;